<div class="main-wrapper mx-auto">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-md-auto p-sm-0 mx-lg-auto">
                    <div class="card mx-4">
                        <div class="card-header">
							<div class="row">
								<div class="col-8">
									<h4 class="">Forgot Password</h4>
								</div>
								<div class="col-4 ">
									<button (click)="back()" class="btn btn-light text-dark float-right"><i
											class="fa fa-reply"></i>&nbsp;<b>Back</b></button>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <form [formGroup]="forgotPasswordForm">
                                <div class="row ">
                                    <div class="col-md-6 col-lg-12 col-sm-6">
                                        <div class="form-group ">
                                            <label class="fw-bold">Email<span class="required">*</span></label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="fa fa-envelope-o"
                                                            aria-hidden="true"></i></span>
                                                </div>
                                                <input class="form-control" type="text" formControlName="email"
                                                    name="email" placeholder="Enter Email Address" 
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"/>
                                            </div>
                                        </div>
                                        <div class="error-msg-area">
                                            <div *ngIf="forgotPasswordForm.controls['email'].errors && (!forgotPasswordForm.controls['email'].pristine|| isforgotPasswordFormSubmitted)"
                                                class="error-msg">
                                                <div [hidden]="!forgotPasswordForm.controls['email'].errors.required">
                                                    Please Enter
                                                    Email</div>
                                            </div>
                                        </div>
                                        <div class="error-msg-area">
                                            <div *ngIf="forgotPasswordForm.controls['email'].errors && forgotPasswordForm.controls['email'].touched"
                                                class="error-msg">
                                                <div *ngIf="forgotPasswordForm.controls['email'].errors.pattern">Please Enter Valid Email 
                                                </div>
                
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <!-- <div class="row ">
                                    <div class="col-md-6 col-lg-12 col-sm-6">
                                        <div class="form-group ">
                                            <label class="fw-bold">Role<span class="required">*</span></label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="fa fa-user"
                                                            aria-hidden="true"></i></span>
                                                </div>
                                                <input class="form-control" type="text" formControlName="role"
                                                    name="role">
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="forgotPasswordForm.controls['role'].errors && (!forgotPasswordForm.controls['role'].pristine|| isforgotPasswordFormSubmitted)"
                                                    class="error-msg">
                                                    <div
                                                        [hidden]="!forgotPasswordForm.controls['role'].errors.required">
                                                        Please Enter
                                                        Role</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </form>
                            <!-- <div class="card-footer"> -->
                                <button type="submit" class="btn btn-primary" style="margin-top:20px;" (click)="onSubmit()">Submit</button>
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>